import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import UnlinkedTransferAccountsPage, { getDefaultUI } from "components/pages/UnlinkedTransferAccountsPage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes from "model";


/**
 * @name CaptureAccountTypeModal
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureAccountTypeModal(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const { options } = branding;
    const hasSelectTypeOfTransferAccountModal = options.transfer_account_type_modal_abi22 === "true";
    const message = `This capture is only shown when ABI22 branding option "Do you show modal to 
        select type of Transfer Account to add?" is set to "Yes".`;
    const uiData = { 
        isActive: true,
        step: 0
    };

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "addUnlinkedTransferAccountModal" ], uiData)
    .submit();

    return hasSelectTypeOfTransferAccountModal
    ? <UnlinkedTransferAccountsPage ui={ ui } /> 
    : <CaptureNotShownView message={ message }/>;;
}